'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  avatar: null,
  email: null,
  firstName: '',
  lastName: '',
  phone: null,
  city: null,
  company: null,
  jobTitle: null,
  vid: null,
  canonicalVid: null
}, 'Visitor');
module.exports = exports['default'];